import React from "react";

export default function BirthChildFrame5({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-5bir1{fill:#7989db}"}</style>
        </defs>
        <path
          d="M472.4 855.42c18.59 21.16 24.71 40.04 26.79 53.58 8.41 54.64-36.68 101.61-17.05 138.82 2.32 4.4 8.78 14.79 4.87 20.46-3.62 5.25-14.44 4.05-22.41 2.44-3.05 2.28-6.71 5.86-7.31 10.72-.57 4.64 2.06 7.15.97 10.72-.77 2.53-3.44 5.66-12.18 7.79.77 2.67 1.49 6.79-.24 10.75-2.61 5.97-8.5 6.3-13.89 10.69-10.43 8.48-4.92 20.7-12.18 27.28-10.38 9.42-35.93-2.67-46.76-7.79-37.57-17.78-49.14-39.92-59.43-35.56-9.1 3.86-10.16 26.88-6.33 44.54 11.63 53.6 77.7 100.87 145.64 105 67.85 4.12 151.49-33.87 160.25-91.57 4.13-27.17-6.54-64.82-36.53-79.88-31.58-15.86-73.9-1.29-93.03 28.25-12.35 19.06-10.94 40.1-9.74 49.2-9.9 4.2-20.94 11.09-27.03 22.87-7.5 14.52-3.7 29.16-5.18 29.26-1.75.13-10.21-20.11-1.39-38.5 6.6-13.76 19.47-19.4 23.38-20.95-.44-8.24-.08-21.85 5.87-36.97.55-1.38 12.39-30.28 41.57-46.1 36.63-19.86 90.52-13.66 120.58 20.1 38.1 42.77 15.79 104.9 12.79 113.27-32.62 90.87-154.68 110.37-161.82 111.41-110.83 16.11-242.34-51.63-286.41-171.46-44.62-121.33 25.04-229.49 33.12-241.6 49.87-74.68 128.97-107.76 132.49-103.26 3.22 4.11-59.53 35.94-91.57 107.16-41.71 92.72-7.04 198.05.97 197.76 5.39-.19-9.26-48 19-84.75 42.91-55.81 131.1-20.36 170.48-72.09 11.62-15.26 21.91-41.94 11.69-91.57Z"
          className="cls-5bir1"
        />
        <path
          d="M1182.04 182.41H406.19c-75.29 0-136.55 61.26-136.55 136.55v375.13h38.46V318.96c0-54.09 44-98.09 98.09-98.09h775.85c54.09 0 98.09 44 98.09 98.09v775.85c0 54.09-44 98.09-98.09 98.09H768.68v38.46h413.36c75.29 0 136.55-61.26 136.55-136.55V318.96c0-75.29-61.26-136.55-136.55-136.55Z"
          className="cls-5bir1"
        />
        {children}
      </g>
    </svg>
  );
}
